/*
 * Jira Ticket:
 * Created Date: Thu, 4th Jun 2020, 09:43:10 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import list from './list';
import create from './create';
import edit from './edit';
import icon from '@material-ui/icons/Assessment';

export default {
  list,
  create,
  edit,
  icon,
};
